<user-resources-list [loaded]="loaded"
                     [resourcePermissionType]="resourcePermissionType"
                     [data]="data"
                     title="Tables"
                     i18n-title="@@collections">
</user-resources-list>
